export default __webpack_public_path__ + "static/media/problema-09.40c7d5fc.webp";